var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16669 6.33325C3.16669 4.09408 3.16669 2.9745 3.86231 2.27887C4.55793 1.58325 5.67751 1.58325 7.91669 1.58325H11.0834C13.3225 1.58325 14.4421 1.58325 15.1377 2.27887C15.8334 2.9745 15.8334 4.09408 15.8334 6.33325V12.6666C15.8334 14.9057 15.8334 16.0253 15.1377 16.7209C14.4421 17.4166 13.3225 17.4166 11.0834 17.4166H7.91669C5.67751 17.4166 4.55793 17.4166 3.86231 16.7209C3.16669 16.0253 3.16669 14.9057 3.16669 12.6666V6.33325Z",
    stroke: "#797C7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7524 12.6667H6.25243C5.5162 12.6667 5.14809 12.6667 4.84607 12.7477C4.02647 12.9673 3.3863 13.6075 3.16669 14.427",
    stroke: "#797C7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33331 5.54175H12.6666",
    stroke: "#797C7F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33331 8.3125H10.2916",
    stroke: "#797C7F",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 12.6667V15.462C10.2917 15.6802 10.2917 15.7893 10.2165 15.8334C10.1415 15.8775 10.0388 15.8287 9.83337 15.7311L8.84996 15.264C8.78045 15.231 8.7457 15.2145 8.70833 15.2145C8.67097 15.2145 8.63621 15.231 8.5667 15.264L7.58329 15.7311C7.37788 15.8287 7.27519 15.8775 7.20009 15.8334C7.125 15.7893 7.125 15.6802 7.125 15.462V13.023",
    stroke: "#797C7F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/EducationIcon.a6999c67d986fa0ca74ed16abb62c2fe.svg";
export { ForwardRef as ReactComponent };